import React, { Component, Fragment } from 'react';
import { Input } from 'reactstrap';

import AutoSearchResults from './AutoSearchResults';

class AutoCompleteSearch extends Component {
    constructor() {
        super();

        this.state = {
            inputValue: '',
            matchingSearchValues: [],
            selectedItem: ''
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) {
            this.setState({
                ...this.state,
                inputValue: this.props.inputValue
            });
        }
    }

    autosearch(e) {
        const inputName = e.target.value.toLowerCase();
        let matchingSearchValues = this.getSearchResults(inputName);

        this.setState({
            ...this.state,
            inputValue: e.target.value,
            matchingSearchValues: matchingSearchValues
        });

        this.props.changeState(e);
    }

    getSearchResults(inputName) {
        let matchingSearchValues = [];
        const inputNameLength = inputName.length;

        if (inputNameLength >= 1) {
            // filter searchValue for matches with the user input
            matchingSearchValues = this.props.searchValues.filter((searchValue) => {

                if (searchValue[this.props.inputName].toLowerCase().includes(inputName)) {
                    return searchValue;
                }
            });
        }

        return matchingSearchValues;
    }

    selectElement(searchValue) {
        this.setState({
            ...this.state,
            selectedItem: searchValue,
            matchingSearchValues: []
        }, () => this.props.changeState(null, searchValue, this.props.inputName));
    }

    render() {

        return (
            <Fragment>
                <Input
                    id={this.props.inputId}
                    type='text'
                    name={this.props.inputName}
                    invalid={this.props.isEmptyField ? true : false}
                    placeholder={this.props.placeholder}
                    autoComplete="off"
                    value={this.state.inputValue}
                    onChange={(e) => this.autosearch(e)}
                    onBlur={
                        () => {
                            setTimeout(
                                () => this.setState({ ...this.state, matchingSearchValues: [] }),
                                400
                            );
                        }
                    }
                    style={this.props.inputStyle}
                />

                <AutoSearchResults
                    inputName={this.props.isRestaurantNamesInBrand ? 'restaurantName' : this.props.inputName}
                    comparisonValue={this.props.comparisonValue}
                    matchingSearchValues={this.state.matchingSearchValues}
                    selectElement={this.selectElement.bind(this)}
                />

            </Fragment>
        );
    }
}

export default AutoCompleteSearch;



// WEBPACK FOOTER //
// ./src/components/central/autosearch/AutoCompleteSearch.js